import DoneIcon from "@mui/icons-material/Done";
import { Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import "./WizardHeader.scss";

interface StepDoneProps {
  hideMobilClass: string;
  text: string;
  url: string;
}

const StepDone = ({ hideMobilClass, text, url }: StepDoneProps) => {
  return (
    <div className={`stepItem${hideMobilClass ? ` ${hideMobilClass}` : ""}`}>
      <div className="stepItemBox stepItemBoxDone">
        <DoneIcon sx={{ fontSize: 16 }} />
      </div>
      <div className="stepItemText">
        <Link
          to={url}
          component={RouterLink}
          className="stepItemLink"
          sx={{
            color: "#DB0F0F",
            textDecoration: "none",
            textDecorationColor: "#DB0F0F",
          }}
        >
          {text}
        </Link>
      </div>
    </div>
  );
};

export default StepDone;
